import { Order } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

type OrderIdArg = Pick<Order, 'businessId'>;

@Pipe({ name: 'orderId', standalone: true })
export class OrderIdPipe implements PipeTransform {
  public transform(value: OrderIdArg): string {
    return value.businessId;
  }
}
